import React from 'react';
import { useTranslation } from 'react-i18next';
import './TeamModals.scss';

type Props = {
    open: boolean;
    hostedInvoiceUrl: string | null;
    onClose: () => void;
};

const PayInvoiceModal: React.FC<Props> = ({ open, hostedInvoiceUrl, onClose }) => {
    const { t } = useTranslation();
    if (!open) return null;

    return (
        <div className="modalOverlay">
            <div className="modal">
                <h2>{t('pages.team.payInvoice.title')}</h2>
                <p>{t('pages.team.payInvoice.description')}</p>

                <div className="modalActions">
                    <button className="button button-secondary" onClick={onClose}>
                        {t('pages.common.close')}
                    </button>

                    <button
                        className="button button-ready"
                        onClick={() => {
                            if (hostedInvoiceUrl) window.location.href = hostedInvoiceUrl;
                        }}
                        disabled={!hostedInvoiceUrl}
                    >
                        {t('pages.team.payInvoice.payNow')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PayInvoiceModal;
